import { parse } from 'date-fns';
import { ownerTypeOptions, payTypeOptions, orderTypeOptions, searchFieldTypeOptions, } from '@/constants/deliveryHistory';
import { whereOperators } from '@/lib/query-parameter/filter';
import { B2BDistributorIds } from '@/constants';
import dateFormatType from '@/constants/dateFormatType';
const { B2BDistributorId } = B2BDistributorIds;
const dateFormat = dateFormatType.DATE;
export default {
    getterCurrentStatusCodeTotal: ({ paginationData }) => paginationData.total,
    getterPageSize: ({ filterOption }) => filterOption.pageSize,
    getterBetweenDate: ({ filterOption }) => () => [
        ...filterOption.betweenDate,
    ],
    getterBetweenDateForDateType: ({ filterOption }) => {
        const [startDate, endDate,] = filterOption.betweenDate;
        return [
            new Date(startDate),
            new Date(endDate),
        ];
    },
    /**
     * betweenDate를 timestamp로 변경
     * @param {Object} state
     * @returns {Array}
     */
    getterBetweenDateToTimeStamp: ({ filterOption }) => {
        const dateObject = new Date();
        const [date1, date2,] = filterOption.betweenDate;
        if (!date1 || !date2) {
            return [];
        }
        const [d1, d2,] = [
            date1,
            date2,
        ].map((it) => parse(it, dateFormat, dateObject));
        return [
            d1.setHours(0, 0, 0, 0),
            d2.setHours(23, 59, 59, 999),
        ];
    },
    getterDeliveryHistoryList: ({ list }) => list ?? [],
    getterPaginationData: ({ paginationData }) => {
        const { pageNumber, pages, } = paginationData;
        return {
            pageNumber,
            pages,
        };
    },
    getterHubTypeParam: ({ filterOption }, getters, rootState, rootGetters) => {
        const { hubType } = filterOption;
        const [ALL, OWN, SHARE, B2B,] = ownerTypeOptions;
        const isHead = rootGetters['user/isHead'];
        const targetField = isHead ? 'distributorId' : 'hubId';
        const notOwnTargetField = isHead ? 'allocatedDistributorId' : 'allocatedHubId';
        const targetValue = rootGetters[`user/${targetField}`];
        return {
            // 전체
            [ALL.value]: [],
            // 자사: 현재 관제허브 id == **Id가 일치
            [OWN.value]: [
                {
                    condition: whereOperators.equals,
                    field: targetField,
                    value: targetValue,
                },
            ],
            // 공유: **Id와 배차허브 아이디가 같고 총판이 H0095가 아닌 것 and 발주허브가 관제허브가 아닌 것
            [SHARE.value]: [
                {
                    condition: whereOperators.notEquals,
                    field: targetField,
                    value: targetValue,
                },
                {
                    condition: whereOperators.equals,
                    field: notOwnTargetField,
                    value: targetValue,
                },
                {
                    condition: whereOperators.notEquals,
                    field: 'distributorId',
                    value: B2BDistributorId,
                },
            ],
            // B2B: 총판코드 H0095 인 것
            [B2B.value]: [
                {
                    condition: whereOperators.equals,
                    field: notOwnTargetField,
                    value: targetValue,
                },
                {
                    condition: whereOperators.equals,
                    field: 'distributorId',
                    value: B2BDistributorId,
                },
            ],
        }[hubType];
    },
    getterPayTypeParam: ({ filterOption }) => {
        const [ALL, PRE_PAY_AMOUNT, PAY_CARD_AMOUNT, PAY_CASH_AMOUNT,] = payTypeOptions;
        const { payType } = filterOption;
        if (payType === ALL.value) {
            return [];
        }
        return {
            [PRE_PAY_AMOUNT.value]: [
                {
                    condition: whereOperators.greaterOrEquals,
                    field: PRE_PAY_AMOUNT.field,
                    value: 1,
                },
            ],
            [PAY_CARD_AMOUNT.value]: [
                {
                    condition: whereOperators.greaterOrEquals,
                    field: PAY_CARD_AMOUNT.field,
                    value: 1,
                },
            ],
            [PAY_CASH_AMOUNT.value]: [
                {
                    condition: whereOperators.greaterOrEquals,
                    field: PAY_CASH_AMOUNT.field,
                    value: 1,
                },
            ],
        }[payType];
    },
    getterOrderTypeParam: ({ filterOption }) => {
        const [ALL, DELIVERY, QUICK,] = orderTypeOptions;
        const { orderType } = filterOption;
        if (orderType === ALL.value) {
            return [];
        }
        return {
            [DELIVERY.value]: [
                {
                    condition: whereOperators.equals,
                    field: 'typeCode',
                    value: DELIVERY.value,
                },
            ],
            [QUICK.value]: [
                {
                    condition: whereOperators.equals,
                    field: 'typeCode',
                    value: QUICK.value,
                },
            ],
        }[orderType];
    },
    getterSearchFieldTypeParam: ({ filterOption }) => {
        const [STORE_NAME, ALLOCATED_WORKER_NAME, ALLOCATED_HUB_NAME, HUB_NAME, DROP_ADDRESS_JIBUN, TODAY_NUMBER, ORDER_ID,] = searchFieldTypeOptions;
        const { value, field } = filterOption.searchWord;
        return {
            [STORE_NAME.value]: [
                {
                    condition: whereOperators.like,
                    field: STORE_NAME.field,
                    value,
                },
            ],
            [ALLOCATED_WORKER_NAME.value]: [
                {
                    condition: whereOperators.like,
                    field: ALLOCATED_WORKER_NAME.field,
                    value,
                },
            ],
            [ALLOCATED_HUB_NAME.value]: [
                {
                    condition: whereOperators.like,
                    field: ALLOCATED_HUB_NAME.field,
                    value,
                },
            ],
            [HUB_NAME.value]: [
                {
                    condition: whereOperators.like,
                    field: HUB_NAME.field,
                    value,
                },
            ],
            [DROP_ADDRESS_JIBUN.value]: [
                {
                    condition: whereOperators.like,
                    field: DROP_ADDRESS_JIBUN.field,
                    value,
                },
            ],
            [DROP_ADDRESS_JIBUN.value]: [
                {
                    condition: whereOperators.like,
                    field: DROP_ADDRESS_JIBUN.field,
                    value,
                },
            ],
            [TODAY_NUMBER.value]: [
                {
                    condition: whereOperators.equals,
                    field: TODAY_NUMBER.field,
                    value,
                },
            ],
            [ORDER_ID.value]: [
                {
                    condition: whereOperators.equals,
                    field: ORDER_ID.field,
                    value,
                },
            ],
        }[field];
    },
};
